module.exports = __webpack_public_path__ + "media/images/business/icon-case-effects-b9d33bafcc5f8af1268053a7b634c81d.svg";